import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { FlatPageRouteControl } from "@app/components/FlatPageRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { AssetClassAnalysisPerformanceRisk } from "./AssetClassAnalysisPerformanceRisk";
import { assetClassAnalysisAnalyzeHistoricalAnalysisPages } from "@app/const/route.const";
import { AssetClassAnalysisSectorAnalysis } from "./AssetClassAnalysisSectorAnalysis";
import { AssetClassAnalysisDistanceFromTrend } from "./AssetClassAnalysisDistanceFromTrend";
import { AssetClassAnalysisMultiPeriodReturn } from "./AssetClassAnalysisMultiPeriodReturn";
import { AssetClassAnalysisIndexCompare } from "./AssetClassAnalysisIndexCompare";
export const AssetClassAnalysisHistoricalAnalysis = memo(() => {
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="h2SSemiBold" sx={{ mt: 4 }}>
          Historical Analysis
        </Typography>
      </Box>
      <FlatPageRouteControl
        tabs={[
          {
            url: assetClassAnalysisAnalyzeHistoricalAnalysisPages.performanceRisk,
            label: "Performance Risk",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_PERFORMANCE_RISK,
            content: <AssetClassAnalysisPerformanceRisk />,
          },
          {
            url: assetClassAnalysisAnalyzeHistoricalAnalysisPages.multiPeriodReturn,
            label: "Multi-Period Return",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_MULTI_PERIOD_RETURN,
            content: <AssetClassAnalysisMultiPeriodReturn />,
          },
          {
            url: assetClassAnalysisAnalyzeHistoricalAnalysisPages.distanceFromTrend,
            label: "Distance From Trend",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_DISTANCE_FROM_TREND,
            content: <AssetClassAnalysisDistanceFromTrend />,
          },
          {
            url: assetClassAnalysisAnalyzeHistoricalAnalysisPages.indexCompare,
            label: "Index Compare",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_INDEX_COMPARE,
            content: <AssetClassAnalysisIndexCompare />,
          },
          {
            url: assetClassAnalysisAnalyzeHistoricalAnalysisPages.sectorAnalysis,
            label: "Sector Analysis",
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_SECTOR_ANALYSIS,
            content: <AssetClassAnalysisSectorAnalysis />,
          },
        ]}
        sx={{ mt: 3 }}
      />
    </>
  );
});
